import { object, array, number, SchemaOf, StringSchema } from 'yup';

import { DockerRegistryFormValues } from './types';

export function createDockerRegistryValidationSchema(
  nameValidation: StringSchema<string>
): SchemaOf<DockerRegistryFormValues> {
  return object({
    name: nameValidation,
    environmentGroupIds: array(number().required()),
    accessRows: array(
      object({
        registryId: number().required(),
        userIds: array(number().required()),
        teamIds: array(number().required()),
      })
    ).min(1, 'At least one registry access configuration is required'),
  });
}
